import React from "react";
import { Check, X } from "lucide-react";

const rules = [
  { label: "At least 10 characters", test: (p) => p.length >= 10 },
  { label: "One uppercase letter", test: (p) => /[A-Z]/.test(p) },
  { label: "One lowercase letter", test: (p) => /[a-z]/.test(p) },
  { label: "One number", test: (p) => /\d/.test(p) },
  { label: "One symbol", test: (p) => /[^A-Za-z0-9]/.test(p) },
];

export default function PasswordRules({ password = "" }) {
  return (
    <div className="rounded-xl border border-brand-line bg-brand-sidebar/60 p-3 grid grid-cols-2 gap-x-4 gap-y-1.5" data-testid="password-rules">
      {rules.map((r, i) => {
        const pass = r.test(password);
        return (
          <div key={i} className="flex items-center gap-1.5 text-xs">
            {pass ? <Check className="w-3.5 h-3.5 text-brand" /> : <X className="w-3.5 h-3.5 text-brand-muted/50" />}
            <span className={pass ? "text-brand-ink" : "text-brand-muted"}>{r.label}</span>
          </div>
        );
      })}
    </div>
  );
}
